
import React from 'react';
export const setTippyContentReact = (content, lineBreak = '<br>') => {
	if (content) {
		const contentLines = content.split(lineBreak);
		const res = [];
		if (contentLines.length) {
			for (let i = 0; i < contentLines.length; i++) {
				res.push(contentLines[i]);
				if (i < contentLines.length - 1) {
					res.push(<br key={i} />);
				}
			}
			return res;
		}

	}
	return content;
};
